/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { Marker } from 'commons/js/components/Map'
import { VOID_PARKING_ICON_IMAGE } from '../../../constants'
import PriceLabel from './PriceLabel'
import { defaultLocale, currentLocale } from 'commons/js/locale'
import { IntlProvider } from 'react-intl'
import { messages } from 'commons/js/messages'
import theme from 'parking-search-map/js/theme'
import { EPProvider } from '@elparking/components'
import convertConstantToEPProviderFormat from 'commons/js/util/coverterGlobalConfig'

import {
    HEIGHT_PX,
    ARROW_HEIGHT_PX,
    SHADOW_WIDTH_PX,
} from './constants'

class PriceMarker extends React.PureComponent {
    static propTypes = {
        parking: PropTypes.object,
        zIndex: PropTypes.number,
        isMarked: PropTypes.bool,
        onClick: PropTypes.func,
    }

    render () {
        const { parking, zIndex, onClick, isMarked } = this.props
        const position = { lat: parking.latitude, lng: parking.longitude }
        const labelAnchor = { x: 0, y: (HEIGHT_PX + ARROW_HEIGHT_PX + SHADOW_WIDTH_PX + 10) }
        const labelStyle = { transform: 'translateX(-50%)' }

        return (
            <Marker
              icon={VOID_PARKING_ICON_IMAGE}
              labelAnchor={labelAnchor}
              labelStyle={labelStyle}
              zIndex={zIndex}
              onClick={onClick}
              position={position}
            >
                <IntlProvider locale={currentLocale} defaultLocale={defaultLocale} messages={messages[currentLocale]}>
                    <EPProvider theme={theme} {...convertConstantToEPProviderFormat()}>
                        <PriceLabel isMarked={isMarked} parking={parking} />
                    </EPProvider>
                </IntlProvider>
            </Marker>
        )
    }
}

export default PriceMarker
